import { toast } from "react-toastify";
import { NavLink } from "react-router-dom";

const Alertbox = (msg = "success", type = "success", delay,position="bottom-right", groupLink="") => {
  switch (type) {
    case "success":
      return toast.success(
        <div className="alert-inner alert-success">
          <div className="alert-inner-sec">
            <div className="msg-header success-header"></div>
            <div className="msg success-txt">{msg}</div>
          </div>
          <span className="alert-divider"></span>
        </div>,
        {
        //   icon: (<SuccessIcon/>),
          position: position,
          autoClose: delay,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        }
      );
    case "error":
    return toast.error(
        <div className="alert-inner ">
          <div className="alert-inner-sec">
            <div className="msg-header error-header">Something is wrong!</div>
            <div className="msg error-txt">{msg}</div>
          </div>
          <span className="alert-divider"></span>
        </div>,
        {
        //   icon:(<ErrorIcon/>),
          position: position,
          autoClose: delay,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        }
      );
      
      case "error-toast":
        return toast.error(
          <div className="alert-inner">
            <div className="alert-inner-sec">
              <div className="msg-header error-header">Error</div>
              <div className="msg error-txt">{msg} <NavLink target="_blank" to={groupLink}>{groupLink} </NavLink></div>
            </div>
            <span className="alert-divider"></span>
          </div>,
          {
            // icon:(<ErrorIcon/>),
            position: position,
            autoClose: delay,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          }
        );
    case "warning":
      return toast.warning(
        <div className="alert-inner">
        <div className="alert-inner-sec">
          <div className="msg-header warning-header">Warning!</div>
          <div className="msg warning-txt">{msg}</div>
        </div>
        <span className="alert-divider"></span>
      </div>,
        {
        //   icon:(<WarningIcon/>),
          position: position,
          autoClose: delay,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        }
      );
      case "warning-toast":
      return toast.warning(
        <div className="alert-inner">
        <div className="alert-inner-sec">
          <div className="msg-header warning-header">Warning!</div>
          <div className="msg warning-txt">{msg}</div>
        </div>
        <span className="alert-divider"></span>
      </div>,
        {
        //   icon:(<WarningIcon/>),
          position: position,
          autoClose: delay,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        }
      );
    default:
      return toast.warning(
        <div className="alert-inner">
          <div className="alert-inner-sec">
            <div className="msg-header warning-header">Warning!</div>
            <div className="msg warning-txt">{msg}</div>
          </div>
          <span className="alert-divider"></span>
        </div>,
        {
        //   icon:(<WarningIcon/>),
          position: position,
          autoClose: delay,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        }
      );
  }
};

export default Alertbox;
